var _circle, _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecondPlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 34,
    viewBox: "0 0 30 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.9849,
    cy: 15.502,
    r: 13.3198,
    fill: "#B7B7B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3455_40624)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15.0059,
    cy: 15.4942,
    r: 10.6559,
    transform: "rotate(50.7384 15.0059 15.4942)",
    fill: "url(#paint0_linear_3455_40624)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M14.7249 15.1504C12.7864 22.6017 6.9731 22.524 6.9731 22.524C6.9731 22.524 0.125984 14.8959 8.26223 7.2437C16.779 1.05913 23.2564 8.75047 23.2564 8.75047C23.2564 8.75047 16.6634 7.69904 14.7249 15.1504Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9041 21V19.2273L15.0462 15.392C15.3984 15.0511 15.6939 14.7443 15.9325 14.4716C16.175 14.1989 16.3587 13.9318 16.4837 13.6705C16.6087 13.4053 16.6712 13.1193 16.6712 12.8125C16.6712 12.4716 16.5935 12.178 16.4382 11.9318C16.2829 11.6818 16.0708 11.4905 15.8018 11.358C15.5329 11.2216 15.228 11.1534 14.8871 11.1534C14.531 11.1534 14.2204 11.2254 13.9553 11.3693C13.6901 11.5133 13.4856 11.7197 13.3416 11.9886C13.1977 12.2576 13.1257 12.5777 13.1257 12.9489H10.7905C10.7905 12.1875 10.9628 11.5265 11.3075 10.9659C11.6522 10.4053 12.1352 9.97159 12.7564 9.66477C13.3776 9.35795 14.0935 9.20455 14.9041 9.20455C15.7375 9.20455 16.4628 9.35227 17.0803 9.64773C17.7015 9.93939 18.1844 10.3447 18.5291 10.8636C18.8738 11.3826 19.0462 11.9773 19.0462 12.6477C19.0462 13.0871 18.959 13.5208 18.7848 13.9489C18.6143 14.3769 18.3094 14.8523 17.87 15.375C17.4306 15.8939 16.8113 16.517 16.0121 17.2443L14.3132 18.9091V18.9886H19.1996V21H10.9041Z",
    fill: "#E6E6E6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3455_40624",
    x: 0.797651,
    y: 4.83789,
    width: 28.4164,
    height: 28.4164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.55196
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.77598
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3455_40624"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3455_40624",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3455_40624",
    x1: 14.797,
    y1: 3.68745,
    x2: 21.2824,
    y2: 27.0452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8B8B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondPlace);
export default __webpack_public_path__ + "static/media/second_place.f0b3b96440e4e189e939b0beb0dbcbe2.svg";
export { ForwardRef as ReactComponent };